export default __webpack_public_path__ + "static/media/crypto.81ad71df.png";